import React, { useEffect, useState, forwardRef } from "react";
import img1 from "../assets/im1.png";
import imgtest1 from "../assets/services (1).png";
import imgtest2 from "../assets/services (2).png";
import chatIcon from "../assets/Chat.svg";
import videoIcon from "../assets/Video.svg";
import personIcon from "../assets/Profile.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules"; // Import Autoplay module
import img4 from "../assets/slider1.png";
import img2 from "../assets/slider2.png";
import img3 from "../assets/slider3.png";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";
import { FreeMode } from "swiper/modules";
import { Carousel, Card, Row, Col } from "react-bootstrap";
import { AnimatePresence, motion } from "framer-motion";
import about1 from '../assets/aboutus/Rectangle 39.png'
import about2 from '../assets/aboutus/Rectangle 40.png'
import about3 from '../assets/aboutus/Rectangle 41.png'
import about4 from '../assets/aboutus/Rectangle 42.png'
import about5 from '../assets/aboutus/Rectangle 43.png'
import about6 from '../assets/aboutus/Rectangle 44.png'
import about7 from '../assets/aboutus/Rectangle 45.png'
import about8 from '../assets/aboutus/Rectangle 46.png'


const imagesarr = [about1, about2, about3, about4, about5, about6, about7, about8];

const Services = forwardRef(({ aboutRef, getStartedRef }, ref) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const chunkArray = (arr, size) => {
    return arr.reduce(
      (acc, _, i) => (i % size ? acc : [...acc, arr.slice(i, i + size)]),
      []
    );
  };
  const [progress, setProgress] = useState([0, 0, 0]);
  const [step, setStep] = useState(0); // Track which bar is filling
  const [stopStepMovement, setStopStepMovement] = useState(false);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  console.log(step)
  // const variants = {
  //   initial: isMobile ? { opacity: 0, x: 50 } : { opacity: 0, y: 20 }, // Enter from right (mobile) or below (desktop)
  //   animate: {
  //     opacity: 1,
  //     x: 0,
  //     y: 0,
  //     transition: { duration: 0.5, ease: "easeInOut" },
  //   }, // Come to position
  //   exit: isMobile ? { opacity: 0, x: -50 } : { opacity: 0, y: -20 }, // Exit left (mobile) or up (desktop)
  // };
  const variants = {
    initial: {
      opacity: 0,
      scale: 1.05,
    },

    animate: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 1.8,
        ease: [0.22, 1, 0.36, 1],
      },
    },

    exit: {
      opacity: 0,
      scale: 0.97,
      transition: {
        duration: 1.8,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  };


  const variantsText = {
    initial: isMobile
      ? { opacity: 0, x: 50 }
      : { opacity: 0, y: 20 },

    animate: {
      opacity: 1,
      x: 0,
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeInOut",
      },
    },

    exit: isMobile
      ? { opacity: 0, x: -50 }
      : { opacity: 0, y: -20 },
  };

  const getImage = () => {
    if (step === 0) return img1;
    if (step === 1) return imgtest1;
    return imgtest2;
  };
  const getText = () => {
    if (step === 0)
      return `Anything worth having is worth fighting for.
When things get difficult in a relationship, it means there’s something that needs attention and care.
Let’s patch up.`;

    if (step === 1)
      return `Sometimes things are not meant to last—and moving on is never easy. But you don't have to go through it alone. We'll guide you toward clarity, peace, and a fresh start. Let's Move On!`;

    if (step === 2)
      return `Discover how well you and your partner align in values, expectations, and goals. Make the most important decision of your life—with assurance. Let's check your compatibility!`;

    return "";
  };
  // useEffect(() => {
  //   if (stopStepMovement == false) {
  //     if (step < 3) {
  //       const timer = setTimeout(() => {
  //         setProgress((prev) => {
  //           const newProgress = [...prev];
  //           newProgress[step] = 100; // Fill the current progress bar
  //           return newProgress;
  //         });
  //         setStep(step + 1); // Move to the next progress bar
  //       }, 4000); // 4 seconds per bar

  //       return () => clearTimeout(timer);
  //     } else {
  //       // Reset all progress bars after the last one fills
  //       const resetTimer = setTimeout(() => {
  //         setProgress([0, 0, 0]);
  //         setStep(0); // Restart process
  //       }, 4000); // 4 seconds after last bar fills

  //       return () => clearTimeout(resetTimer);
  //     }
  //   }
  // }, [step]);

  useEffect(() => {
    if (!stopStepMovement) {
      if (step < 3) {
        // Immediately set only the current bar to 100%, others to 0
        setProgress([0, 0, 0].map((_, i) => (i === step ? 100 : 0)));

        const timer = setTimeout(() => {
          setStep((prev) => prev + 1); // Move to next bar
        }, 6000); // Duration of each bar's animation

        return () => clearTimeout(timer);
      } else {
        // Immediately restart without delay
        setProgress([0, 0, 0]);
        setStep(0);
      }
    }
  }, [step, stopStepMovement]);
  console.log(step);
  const handleScrollToForm = () => {
    if (getStartedRef?.current) {
      const yOffset = 1000; // Adjust offset if needed (to prevent hiding behind navbar)
      const y =
        aboutRef.current.getBoundingClientRect().top + window.scrollY + yOffset;

      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };
  console.log(step);
  return (
    <div className="bg-white rounded-5">
      <div className="service-main color-light-red py-5">
        <div className="container my-">
          <span
            className=""
            style={{
              fontFamily: "DM Sans",
              fontStyle: "normal",
              color: "#212121",
              fontWeight: "400",
              fontSize: "54px",
              lineHeight: "72px",
              wordSpacing: "5px",
            }}
          >
            <span style={{ color: "#cc2b52" }}>89%</span> people developed healthier relationships though counselling
          </span>

         <div className="my-4 mt-5 stats-section">
  <div className="row g-4">

    <div className="col-6 col-lg-3 d-flex gap-3">
      <div className="vr"></div>

      <div className="d-flex flex-column">
        <span
          style={{
            color: "#3B486E",
            fontSize: "72px",
            fontWeight: "500",
            fontFamily: "DM Sans",
          }}
        >
          1000+
        </span>

        <span
          style={{
            color: "#3B486E",
            fontSize: "18px",
            fontWeight: "400",
            fontFamily: "DM Sans",
          }}
        >
          Trusted Clients
        </span>
      </div>
    </div>

    <div className="col-6 col-lg-3 d-flex gap-3">
      <div className="vr"></div>

      <div className="d-flex flex-column">
        <span
          style={{
            color: "#3B486E",
            fontSize: "72px",
            fontWeight: "500",
            fontFamily: "DM Sans",
          }}
        >
          100+
        </span>

        <span
          style={{
            color: "#3B486E",
            fontSize: "18px",
            fontWeight: "400",
            fontFamily: "DM Sans",
          }}
        >
          Certified Experts
        </span>
      </div>
    </div>

    <div className="col-6 col-lg-3 d-flex gap-3">
      <div className="vr"></div>

      <div className="d-flex flex-column">
        <span
          style={{
            color: "#3B486E",
            fontSize: "72px",
            fontWeight: "500",
            fontFamily: "DM Sans",
          }}
        >
          20+
        </span>

        <span
          style={{
            color: "#3B486E",
            fontSize: "18px",
            fontWeight: "400",
            fontFamily: "DM Sans",
          }}
        >
          Years of Experience
        </span>
      </div>
    </div>

    <div className="col-6 col-lg-3 d-flex gap-3">
      <div className="vr"></div>

      <div className="d-flex flex-column">
        <span
          style={{
            color: "#3B486E",
            fontSize: "72px",
            fontWeight: "500",
            fontFamily: "DM Sans",
          }}
        >
          5+
        </span>

        <span
          style={{
            color: "#3B486E",
            fontSize: "18px",
            fontWeight: "400",
            fontFamily: "DM Sans",
          }}
        >
          Language Support
        </span>
      </div>
    </div>

  </div>
</div>
        </div>
      </div>
      <div className="py-5 container d-flex flex-column" ref={ref}>
        <span
          style={{
            color: "#CC2B52",
            fontSize: "20px",
            fontFamily: "DM Sans",
            lineHeight: "32px",
          }}
        >
          Services
        </span>
        <span
          className="my-2"
          style={{ color: "#212121", fontSize: "48px", lineHeight: "62px" }}
        >
          Our Therapists are here to guide your next step.
        </span>
        {/* <span
          className="my-1"
          style={{ color: "#6E6E6E", fontSize: "18px", lineHeight: "28px" }}
        >
          80% Satisfaction Rate: 8 out of 10 clients report improved
          relationships after seeking our services.{" "}
        </span> */}
        <div className="row gap-0 pt-5">
          <div className="col-5 d-flex flex-column justify-content-between">
            <div className="d-flex flex-column">
              <hr className="m-0" style={{ border: "1px solid #f7ebee" }}></hr>
              <span
                className="py-3"
                onClick={() => {
                  setStopStepMovement(true);
                  setStep(0);
                }}
                style={{
                  color: `${step == 0 ? "#CC2B52" : "#e3b8c3"}`,
                  fontSize: "28px",
                  fontFamily: "DM Sans",
                  fontWeight: "400",
                  cursor: "pointer",
                }}
              >
                Patchup
              </span>
              {/* <hr className="m-0" style={{ border: "1px solid #f7ebee" }}></hr> */}
              <div
                // key={index}
                style={{ position: "relative", marginBottom: "10px" }}
              >
                {/* Background Line */}
                <hr className="m-0" style={{ border: "1px solid #f7ebee" }} />

                {/* Animated Progress Line */}
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: `${stopStepMovement ? 0 : progress[0]}%`,
                    height: "1px",
                    background: "#cc2e58", // Change color if needed
                    transition: progress[0] > 0 || stopStepMovement == true ? "width 4s linear" : "none",
                  }}
                />
              </div>
              <span
                className="py-3"
                onClick={() => {
                  setStopStepMovement(true);
                  setStep(1);
                }}
                style={{
                  color: `${step == 1 ? "#CC2B52" : "#e3b8c3"}`,
                  fontSize: "28px",
                  fontFamily: "DM Sans",
                  fontWeight: "400",
                  cursor: "pointer",
                }}
              >
                Move on
              </span>
              {/* <hr className="m-0" style={{ border: "1px solid #f7ebee" }}></hr> */}
              <div
                // key={index}
                style={{ position: "relative", marginBottom: "10px" }}
              >
                {/* Background Line */}
                <hr className="m-0" style={{ border: "1px solid #f7ebee" }} />

                {/* Animated Progress Line */}
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: `${stopStepMovement ? 0 : progress[1]}%`,
                    height: "1px",
                    background: "#cc2e58", // Change color if needed
                    transition: progress[1] > 0 || stopStepMovement == true ? "width 4s linear" : "none",
                    cursor: "pointer",
                  }}
                />
              </div>
              <span
                className="py-3"
                onClick={() => {
                  setStopStepMovement(true);
                  setStep(2);
                }}
                style={{
                  color: `${step == 2 ? "#CC2B52" : "#e3b8c3"}`,
                  fontSize: "28px",
                  fontFamily: "DM Sans",
                  fontWeight: "400",
                  cursor: "pointer",
                }}
              >
                Check Compantibility
              </span>
              {/* <hr className="m-0" style={{ border: "1px solid #f7ebee" }}></hr> */}
              <div
                // key={index}
                style={{ position: "relative", marginBottom: "10px" }}
              >
                {/* Background Line */}
                <hr className="m-0" style={{ border: "1px solid #f7ebee" }} />

                {/* Animated Progress Line */}
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: `${stopStepMovement ? 0 : progress[2]}%`,
                    height: "1px",
                    background: "#cc2e58", // Change color if needed
                    transition: progress[2] > 0 || stopStepMovement == true ? "width 4s linear" : "none",
                  }}
                />
              </div>
            </div>
            <div className="d-flex flex-column">
              <AnimatePresence mode="wait">
                <motion.span
                  key={`text-${step}`}
                  className="mb-3"
                  style={{
                    color: "#212121",
                    fontSize: "18px",
                    lineHeight: "32px",
                    fontFamily: "DM Sans",
                  }}
                  variants={variantsText}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                >
                  {getText()}
                </motion.span>
              </AnimatePresence>


              <div className="">
                <button
                  className="about-btn mt-4"
                  onClick={handleScrollToForm}
                >
                  Get Started →
                </button>
              </div>
            </div>
          </div>
          <div className="col-7">
            <div className="py-3 " style={{ backgroundColor: "#f7ebee", }}>
              <div
                className="d-flex justify-content-center align-items-center py-5 "
                // style={{
                //   backgroundColor: "#f7ebee",
                //   overflow: "hidden",
                //   height: "300px", // Ensure consistent height
                // }}
                style={{ position: "relative", height: "500px", overflow: "hidden", backgroundColor: "#f7ebee", }}
              >
                <AnimatePresence mode="sync">

                  <motion.img
                    key={step}
                    className="w-75 my-2"
                    src={getImage()}
                    variants={variants}
                    initial="initial"
                    animate="animate"
                    exit="exit"
                    style={{
                      position: "absolute",
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />

                </AnimatePresence>
              </div></div>
            {/* <div style={{ position: "relative", height: "400px", overflow: "hidden" }} >
  <AnimatePresence mode="sync">
    <motion.img
      key={step}
      className="w-75 my-2"
      src={getImage()}
      variants={variants}
      initial="initial"
      animate="animate"
      exit="exit"
      style={{
        position: "absolute",
        width: "100%",
        height: "100%",
        objectFit: "contain",
      }}
    />
  </AnimatePresence>
</div> */}
          </div>
        </div>
      </div>
      <div className="service-gradient pb-5">
        <div className="container mt-5 d-flex flex-column">
          <div className="mt-2 d-flex flex-column">
            <span
              className=""
              style={{
                color: "#CC2B52",
                fontSize: "20px",
                fontFamily: "DM Sans",
                lineHeight: "32px",
              }}
            >

            </span>
            <span
              className="my-2"
              style={{ color: "#212121", fontSize: "48px", lineHeight: "62px" }}
            >
              Your Path to a Better Relationship{" "}
            </span>
            <span
              className="my-1"
              style={{ color: "#6E6E6E", fontSize: "18px", lineHeight: "28px" }}
            >

            </span>
          </div>
          <div className="mt-5 row gap-0">
            <div className="col-4">
              <div className="card border border-0 p-5 rounded-5 h-100">
                <div className="d-flex">
                  <span className="background-light-red px-3 py-3 rounded-4 d-flex justify-content-center align-items-center">
                    <img src={chatIcon}></img>
                  </span>
                </div>
                <div className="mt-2">
                  <span
                    className=""
                    style={{
                      color: "#212121",
                      fontSize: "32px",
                      lineHeight: "48px",
                      fontFamily: "DM Sans",
                      fontWeight: "500",
                    }}
                  >
                    Free Online Consultation
                  </span>
                  <div className="mt-3">
                    <span
                      className=""
                      style={{
                        color: "#6e6e6e",
                        fontSize: "18px",
                        lineHeight: "32px",
                        fontFamily: "DM Sans",
                        fontWeight: "400",
                      }}
                    >
                      Begin with a confidential call with our Relationship
                      Associate (RA) to understand your concerns and match you
                      with the right experts.{" "}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-4">
              <div className="card border border-0 p-5 rounded-5 h-100">
                <div className="d-flex">
                  <span className="background-light-red px-3 py-3 rounded-4 d-flex justify-content-center align-items-center">
                    <img src={personIcon}></img>
                  </span>
                </div>
                <div className="mt-2">
                  <span
                    className=""
                    style={{
                      color: "#212121",
                      fontSize: "32px",
                      lineHeight: "48px",
                      fontFamily: "DM Sans",
                      fontWeight: "500",
                    }}
                  >
                    Personalized Expert Team{" "}
                  </span>
                  <div className="mt-3">
                    <span
                      className=""
                      style={{
                        color: "#6E6E6E",
                        fontSize: "18px",
                        lineHeight: "32px",
                        fontFamily: "DM Sans",
                        fontWeight: "400",
                      }}
                    >
                      Get a curated team of specialists, led by a Lead
                      Relationship Expert (LRE) to guide you with a tailored,
                      results-driven approach.
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-4">
              <div className="card border border-0 p-5 rounded-5 h-100">
                <div className="d-flex">
                  <span className="background-light-red px-3 py-3 rounded-4 d-flex justify-content-center align-items-center">
                    <img src={videoIcon}></img>
                  </span>
                </div>
                <div className="mt-2">
                  <span
                    className=""
                    style={{
                      color: "#212121",
                      fontSize: "32px",
                      lineHeight: "48px",
                      fontFamily: "DM Sans",
                      fontWeight: "500",
                    }}
                  >
                    Convenient Online Consultation{" "}
                  </span>
                  <div className="mt-3">
                    <span
                      className=""
                      style={{
                        color: "#6E6E6E",
                        fontSize: "18px",
                        lineHeight: "32px",
                        fontFamily: "DM Sans",
                        fontWeight: "400",
                      }}
                    >
                      Schedule flexible consultations with your LRE and receive
                      detailed reports to track your progress.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ backgroundColor: "#fefcfd" }} ref={aboutRef}>
        <div className="container py-5">
          <div
            style={{
              backgroundColor: "#3B486E",
              padding: "70px 50px",
              borderRadius: "2px",
            }}
          >
            <div className="row align-items-center">
              {/* Left Content */}
              <div className="col-lg-5">
                <div className="d-flex flex-column">
                  <span
                    style={{
                      color: "#e68aa1",
                      fontSize: "20px",
                      fontFamily: "DM Sans",
                      fontWeight: "500",
                    }}
                  >
                    About Us
                  </span>

                  <span
                    className="mt-3"
                    style={{
                      color: "#ffffff",
                      fontSize: "30px",
                      lineHeight: "35px",
                      
                      fontFamily: "outfit",
                      fontWeight: "200",
                    }}
                  >
                    Creating Happier Lives.
                  </span>

                 <div
  className="about-text mt-4"
  style={{
    color: "#E9EBF0",
    fontSize: "16px",
    lineHeight: "24px",
    fontFamily: "Outfit",
    fontWeight: "300",
    width: "100%",
    textAlign: "justify",
  }}
>
<p
  style={{
    marginBottom: "12px",
    textAlign: "left",
    lineHeight: "1.8",
    wordSpacing: "normal",
    letterSpacing: "normal",
  }}
>
  At Patchup, we help relationships thrive—whether you’re rekindling love,
  healing from heartbreak, or finding compatibility. Our team of experts,
  including psychiatrists, psychologists, relationship counsellors, NLP
  practitioners, divorce lawyers, and dating coaches, is here to guide you
  towards emotional well-being and meaningful connections.
</p>
{/* 
  <p style={{ marginBottom: "12px" }}>
    Our team of experts—including psychiatrists, psychologists, relationship
    counsellors, NLP practitioners, divorce lawyers, and dating coaches—is
    here to guide you towards emotional well-being and meaningful connections.
  </p> */}

  <p style={{ marginBottom: "0" }}>
    Let’s create a world of love, growth, and lasting happiness.
  </p>
</div>
                  <button
                    className="about-btn mt-4"
                    onClick={handleScrollToForm}
                  >
                    Get Started →
                  </button>
                </div>
              </div>

              {/* Right Side Auto Carousel */}
              <div className="col-lg-7 mt-lg-0 mt-5">
                <div className="scroll-container">
                  <div className="scroll-wrapper">
                    {[...imagesarr, ...imagesarr].map((image, index) => (
                      <div className="scroll-item" key={index}>
                        <img src={image} alt={`img-${index}`} />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default Services;
